import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import Slide from "@mui/material/Slide";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import cogoToast from "cogo-toast";
import CryptoJS from "crypto-js";
import * as React from "react";
import { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { MdAdd } from "react-icons/md";
import QRCode from "react-qr-code";
import { useSelector } from "react-redux";
import { FileLoader, UploadApi } from "../constants/Constants";
import {
  AWS_Access_Key_Id_Encypt,
  AWS_Bucket_Name,
  AWS_Region,
  AWS_Secret_Access_Key_Encypt,
} from "../constants/bucketCostant";
import CustomizedSnackbars from "./CustomizedSnackbars";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide3({
  email,
  cOpen,
  setCOpen,
  cAccession,
}) {
  let Fold = email;
  const [isOpen, setIsOpen] = React.useState(false);
  const [pass, setPass] = useState("");
  // const [email, setEmail] = useState("");
  const [show, setshow] = useState(false);
  const [modal, setModal] = useState(false);
  const [date, setDate] = React.useState("");
  const [emailToSend, setEmailToSend] = React.useState("");
  const state = useSelector((state) => state.user);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const fullScreen2 = useMediaQuery(theme.breakpoints.down("lg"));
  const [urlSafeEmail, setUrlSafeEmail] = useState("");
  const [urlSafePass, setUrlSafePass] = useState("");
  const [urlSafeDate, setUrlSafeDate] = useState("");
  const [urlSafeFold, setUrlSafeFold] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [nonEditedShareData, setNonEditedShareData] = useState([]);
  const token = localStorage.getItem("token");
  const [selected, setselected] = useState(null);
  const canShareState = useSelector((state) => state.canShare);
  const FolderGet = useSelector((state) => state.FolderGet.FolderName);
  const viewKeyImagesOnly = useSelector((state) => state.isOnlyKeyImages);
  const [isLoadingTiny, setIsLoadingTiny] = useState(false);
  const [ObjData, setObjData] = useState([
    {
      email: "",
      pass: "",
      date: "",
      url: "",
      canUpload: "",
      isKeyImagesOnly: "",
      canShare: "",
    },
  ]);

  const GetFolderShareList = async () => {
    try {
      let response = await axios.get(
        `${FileLoader}/fileloaderv1/files/GetSharedList?FolderName=${Fold}/&awsAccessKeyId=${encodeURIComponent(
          AWS_Access_Key_Id_Encypt()
        )}&awsSecretAccessKey=${encodeURIComponent(
          AWS_Secret_Access_Key_Encypt()
        )}&awsbucketname=${AWS_Bucket_Name()}&Region=${AWS_Region()}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.length > 0) {
        const transformedApiResponse =
          canShareState && FolderGet
            ? response.data
                .filter(
                  (item) =>
                    item.name != null &&
                    item.name != "null" &&
                    item.client === "true"
                )
                .map((item, index) => {
                  return {
                    email: item.name,
                    date: item.expiryDate,
                    pass: item.pass,
                    url: item.url,
                    createdAt: item.urlcreationDate,
                    updatedAt: item.urlupdateDate,
                    canUpload: item.canUpload,
                    isKeyImagesOnly: item.isKeyImagesOnly,
                    canShare: item.canShare,
                    client: item.client,
                  };
                })
            : response.data
                .filter(
                  (item) =>
                    item.name != null &&
                    item.name != "null" &&
                    item.client !== "true"
                )
                .map((item, index) => {
                  return {
                    email: item.name,
                    date: item.expiryDate,
                    pass: item.pass,
                    url: item.url,
                    createdAt: item.urlcreationDate,
                    updatedAt: item.urlupdateDate,
                    canUpload: item.canUpload,
                    isKeyImagesOnly: item.isKeyImagesOnly,
                    canShare: item.canShare,
                    client: item.client,
                  };
                });
        setObjData(transformedApiResponse);
        setNonEditedShareData(transformedApiResponse);
        const transformedApiResponseTiny = await Promise.all(
          response.data.map(async (item, index) => {
            const tempUrl = await TinyTextSharedFolders(item.url);
            return tempUrl;
          })
        );
        setCopiedText(transformedApiResponseTiny);
      } else {
        setObjData([
          {
            email: "",
            pass: "",
            date: "",
            url: "",
          },
        ]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    if (Fold !== "") {
      GetFolderShareList();
    }
  }, [Fold]);

  // let ArrayForRender=[1,1];

  // const onChangeField = (e) => {
  //   setObjData()
  // };
  // //console.log(ObjData, "ObjData");

  // const onChangeField = (index, field, value) => {
  //   const updatedObjData = [...ObjData];
  //   updatedObjData[index] = {
  //     ...updatedObjData[index],
  //     [field]: value,
  //   };
  //   setObjData(updatedObjData);
  // };
  // const onChangeField = (event, i) => {
  //   const value = event.target.value;
  //   const name = event.target.name;
  //   const prevData = [...ObjData];  // Create a new array with the same elements

  //   // Create a new object based on the current element at index i and update the property [name] with the new value
  //   prevData[i] = {
  //     ...prevData[i],
  //     [name]: value
  //   };

  //   // Set the updated array as the new state
  //   setObjData(prevData);
  // };

  const onChangeField = (event, i) => {
    setIsLoadingTiny(true);
    const value = event.target.value;
    const name = event.target.name;
    const type = event.target.type;
    const prevData = [...ObjData];
    let encryptedEmail = "";
    let encryptedPass = "";
    let encryptedDate = "";
    let encryptedFolder = "";

    const valueUpload = prevData[i].canUpload;
    const valueKeyImages = prevData[i].isKeyImagesOnly;
    const valueShare = prevData[i].canShare;
    let urlSafeValue = "";
    let urlSafeKeyImages = "";
    let urlSafeShare = "";
    if (
      valueUpload == undefined ||
      valueUpload == "" ||
      valueUpload == "notofileupload"
    ) {
      if (name == "canUpload") {
        const encryptedValue = CryptoJS.AES.encrypt(
          "yestofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      } else {
        const encryptedValue = CryptoJS.AES.encrypt(
          "notofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      }
    } else {
      if (name == "canUpload") {
        const encryptedValue = CryptoJS.AES.encrypt(
          "notofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      } else {
        const encryptedValue = CryptoJS.AES.encrypt(
          "yestofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      }
    }

    if (viewKeyImagesOnly) {
      const encryptedImages = CryptoJS.AES.encrypt(
        "onlykeyimages",
        secretKey
      ).toString();
      urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");
    } else if (
      valueKeyImages == undefined ||
      valueKeyImages == "" ||
      valueKeyImages == "allimages"
    ) {
      if (name == "onlyKeyImages") {
        const encryptedImages = CryptoJS.AES.encrypt(
          "onlykeyimages",
          secretKey
        ).toString();
        urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");

        const encryptedValue = CryptoJS.AES.encrypt(
          "notofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      } else {
        const encryptedImages = CryptoJS.AES.encrypt(
          "allimages",
          secretKey
        ).toString();
        urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");
      }
    } else {
      if (name == "onlyKeyImages") {
        const encryptedImages = CryptoJS.AES.encrypt(
          "allimages",
          secretKey
        ).toString();
        urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");
      } else {
        const encryptedImages = CryptoJS.AES.encrypt(
          "onlykeyimages",
          secretKey
        ).toString();
        urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");

        const encryptedValue = CryptoJS.AES.encrypt(
          "notofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      }
    }

    if (
      valueShare == undefined ||
      valueShare == "" ||
      valueShare == "noshare"
    ) {
      if (name == "canShare") {
        const encryptedShares = CryptoJS.AES.encrypt(
          "yesshare",
          secretKey
        ).toString();
        urlSafeShare = encryptedShares.replace(/\//g, "bbbb");
      } else {
        const encryptedShares = CryptoJS.AES.encrypt(
          "noshare",
          secretKey
        ).toString();
        urlSafeShare = encryptedShares.replace(/\//g, "bbbb");
      }
    } else {
      if (name == "canShare") {
        const encryptedShares = CryptoJS.AES.encrypt(
          "noshare",
          secretKey
        ).toString();
        urlSafeShare = encryptedShares.replace(/\//g, "bbbb");
      } else {
        const encryptedShares = CryptoJS.AES.encrypt(
          "yesshare",
          secretKey
        ).toString();
        urlSafeShare = encryptedShares.replace(/\//g, "bbbb");
      }
    }

    if (type == "password" || type == "text") {
      encryptedFolder = CryptoJS.AES.encrypt(Fold, secretKey).toString();
      let urlSafefold = encryptedFolder.replace(/\//g, "bbbb");
      setUrlSafeFold(urlSafefold);
      setUrlSafeEmail(urlSafefold);

      encryptedDate = CryptoJS.AES.encrypt(
        prevData[i].date,
        secretKey
      ).toString();
      let urlSafeDateIfEmpty = encryptedDate.replace(/\//g, "bbbb");

      encryptedPass = CryptoJS.AES.encrypt(value, secretKey).toString();
      let urlSafePass = encryptedPass.replace(/\//g, "bbbb");
      setUrlSafePass(urlSafePass);
      prevData[i] = {
        ...prevData[i],
        [name]: value,
        email: Fold,
        url: `${window.origin}/signin/${urlSafefold}/${urlSafePass}/${
          urlSafeDate === "" ? urlSafeDateIfEmpty : urlSafeDate
        }/${urlSafefold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }

    if (type == "date") {
      encryptedFolder = CryptoJS.AES.encrypt(Fold, secretKey).toString();
      let urlSafefold = encryptedFolder.replace(/\//g, "bbbb");
      setUrlSafeFold(urlSafefold);
      setUrlSafeEmail(urlSafefold);

      encryptedPass = CryptoJS.AES.encrypt(
        prevData[i].pass,
        secretKey
      ).toString();
      let urlSafePassIfEmpty = encryptedPass.replace(/\//g, "bbbb");

      encryptedDate = CryptoJS.AES.encrypt(value, secretKey).toString();
      let urlSafeDate = encryptedDate.replace(/\//g, "bbbb");
      setUrlSafeDate(urlSafeDate);
      prevData[i] = {
        ...prevData[i],
        [name]: value,
        url: `${window.origin}/signin/${urlSafefold}/${
          urlSafePass === "" ? urlSafePassIfEmpty : urlSafePass
        }/${urlSafeDate}/${urlSafefold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }

    if (name == "canUpload") {
      encryptedFolder = CryptoJS.AES.encrypt(Fold, secretKey).toString();
      let urlSafefold = encryptedFolder.replace(/\//g, "bbbb");
      setUrlSafeFold(urlSafefold);
      setUrlSafeEmail(urlSafefold);

      encryptedPass = CryptoJS.AES.encrypt(
        prevData[i].pass,
        secretKey
      ).toString();
      let urlSafePassIfEmpty = encryptedPass.replace(/\//g, "bbbb");

      encryptedDate = CryptoJS.AES.encrypt(
        prevData[i].date,
        secretKey
      ).toString();
      let urlSafeDateIfEmpty = encryptedDate.replace(/\//g, "bbbb");

      prevData[i] = {
        ...prevData[i],
        ["canUpload"]:
          valueUpload === "yestofileupload"
            ? "notofileupload"
            : "yestofileupload",
        url: `${window.origin}/signin/${urlSafefold}/${
          urlSafePass === "" ? urlSafePassIfEmpty : urlSafePass
        }/${
          urlSafeDate === "" ? urlSafeDateIfEmpty : urlSafeDate
        }/${urlSafefold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }

    if (name == "onlyKeyImages") {
      encryptedFolder = CryptoJS.AES.encrypt(Fold, secretKey).toString();
      let urlSafefold = encryptedFolder.replace(/\//g, "bbbb");
      setUrlSafeFold(urlSafefold);
      setUrlSafeEmail(urlSafefold);

      encryptedPass = CryptoJS.AES.encrypt(
        prevData[i].pass,
        secretKey
      ).toString();
      let urlSafePassIfEmpty = encryptedPass.replace(/\//g, "bbbb");

      encryptedDate = CryptoJS.AES.encrypt(
        prevData[i].date,
        secretKey
      ).toString();
      let urlSafeDateIfEmpty = encryptedDate.replace(/\//g, "bbbb");

      prevData[i] = {
        ...prevData[i],
        ["isKeyImagesOnly"]:
          valueKeyImages === "onlykeyimages" ? "allimages" : "onlykeyimages",
        ["canUpload"]:
          valueKeyImages === "onlykeyimages"
            ? "notofileupload"
            : prevData[i].canUpload,
        url: `${window.origin}/signin/${urlSafefold}/${
          urlSafePass === "" ? urlSafePassIfEmpty : urlSafePass
        }/${
          urlSafeDate === "" ? urlSafeDateIfEmpty : urlSafeDate
        }/${urlSafefold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }

    if (name == "canShare") {
      encryptedFolder = CryptoJS.AES.encrypt(Fold, secretKey).toString();
      let urlSafefold = encryptedFolder.replace(/\//g, "bbbb");
      setUrlSafeFold(urlSafefold);
      setUrlSafeEmail(urlSafefold);

      encryptedPass = CryptoJS.AES.encrypt(
        prevData[i].pass,
        secretKey
      ).toString();
      let urlSafePassIfEmpty = encryptedPass.replace(/\//g, "bbbb");

      encryptedDate = CryptoJS.AES.encrypt(
        prevData[i].date,
        secretKey
      ).toString();
      let urlSafeDateIfEmpty = encryptedDate.replace(/\//g, "bbbb");

      prevData[i] = {
        ...prevData[i],
        ["canShare"]: valueShare === "yesshare" ? "noshare" : "yesshare",
        url: `${window.origin}/signin/${urlSafefold}/${
          urlSafePass === "" ? urlSafePassIfEmpty : urlSafePass
        }/${
          urlSafeDate === "" ? urlSafeDateIfEmpty : urlSafeDate
        }/${urlSafefold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }

    // Update the URL-safe variables

    // Update the specific field with the new value

    // Set the updated array and URL-safe variables as the new state

    setTinyCopiedText(prevData[i], prevData[i]?.url, i);
    setObjData(prevData);
  };

  const SendEmail = async () => {
    try {
      let fromdata = new FormData();

      let newselectedurl = "";
      try {
        const response = await axios.get(
          `${UploadApi}/apiUpload/api-create?url=${encodeURIComponent(
            selected?.url
          )}`
        );

        if (response.data) {
          newselectedurl = response.data;
        } else {
          newselectedurl = selected?.url;
        }
      } catch (error) {
        newselectedurl = selected?.url;
      }

      fromdata.append("address", emailToSend);
      fromdata.append("subject", " Sharing Study");
      fromdata.append(
        "link",
        `${newselectedurl}\n` + `\nPassword:${selected?.pass}`
      );
      // fromdata.append("userID", `${selected?.email}`);
      fromdata.append("userPass", `${selected?.pass}`);
      const axiosInstance = axios.create({
        baseURL: `${UploadApi}/user/`,
      });
      axiosInstance
        .post("sendEmailLink", fromdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        })
        .then(async (response) => {
          cogoToast.success("Mail send Successfully.", {
            position: "top-right",
          });
          setModal(false);
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  const ShareFolderLink = async (e, i) => {
    let formData = new FormData();
    formData.append("awsAccessKeyId", AWS_Access_Key_Id_Encypt());
    formData.append("awsSecretAccessKey", AWS_Secret_Access_Key_Encypt());
    formData.append(`AccountDetail[0].Name`, e?.email);
    formData.append(`AccountDetail[0].expiryDate`, e?.date);
    formData.append(`AccountDetail[0].password`, e?.pass);
    formData.append(`AccountDetail[0].url`, e?.url);
    formData.append(`AccountDetail[0].canUpload`, e?.canUpload);
    formData.append(`AccountDetail[0].isKeyImagesOnly`, e?.isKeyImagesOnly);
    formData.append(`AccountDetail[0].canShare`, e?.canShare);
    formData.append(`AccountDetail[0].urlCreationDate`, e?.createdAt);
    formData.append(
      `AccountDetail[0].client`,
      canShareState && FolderGet ? true : false
    );
    formData.append("awsbucketname", AWS_Bucket_Name());
    formData.append("Region", AWS_Region());

    if (nonEditedShareData.length > 0) {
      if (
        e?.createdAt != null &&
        e?.createdAt != undefined &&
        nonEditedShareData[i]?.createdAt != null &&
        nonEditedShareData[i]?.createdAt != undefined &&
        e.createdAt === nonEditedShareData[i].createdAt
      ) {
        formData.append(`AccountDetail[0].urlUpdateDate`, "yes");
      }
    }
    let requestBody;

    try {
      let response = await axios.post(
        `${FileLoader}/fileloaderv1/files/ShareFolder?FolderName=${Fold}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data && nonEditedShareData.length > 0) {
        if (
          e?.createdAt != null &&
          e?.createdAt != undefined &&
          nonEditedShareData[i]?.createdAt != null &&
          nonEditedShareData[i]?.createdAt != undefined &&
          e.createdAt === nonEditedShareData[i].createdAt
        ) {
          RemoveSharePerson(nonEditedShareData[i], i);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const saveCredentials = (args) => {
    var data = [];
    if (!localStorage.getItem("dcmCredentails")) {
      data.push(args);
      localStorage.setItem("dcmCredentails", JSON.stringify(data));
    } else {
      data = JSON.parse(localStorage.getItem("dcmCredentails"));
      var filteredData = data.filter((e) => {
        if (e.accession !== args.accession) {
          return e;
        }
      });
      filteredData.push(args);
      localStorage.setItem("dcmCredentails", JSON.stringify(filteredData));
    }
  };

  const ShareData = () => {};

  const AddSharePerson = () => {
    const newObj = {
      email: "",
      pass: "",
      date: "",
    };
    setObjData([...ObjData, newObj]);
  };

  const RemoveSharePerson = async (e, i) => {
    // let formData = new FormData();
    // formData.append(
    //   "awsAccessKeyId",
    //   AWS_Access_Key_Id_Encypt()
    // );
    // formData.append(
    //   "awsSecretAccessKey",
    //   AWS_Secret_Access_Key_Encypt()
    // );
    // formData.append("awsbucketname", process.env.React_App_AWS_Bucket_Name_encypt);

    try {
      let response = await axios.delete(
        // `${DRCoreApi}fileloaderv1/files/DeleteUserByName?FolderName=${Fold}/&name=${e?.email}/`,
        `${FileLoader}/fileloaderv1/files/DeleteUserByName?FolderName=${Fold}/&name=${
          e?.email
        }&awsAccessKeyId=${encodeURIComponent(
          AWS_Access_Key_Id_Encypt()
        )}&awsSecretAccessKey=${encodeURIComponent(
          AWS_Secret_Access_Key_Encypt()
        )}&awsbucketname=${AWS_Bucket_Name()}&Region=${AWS_Region()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {}
    const newArrayForRender = [...ObjData]; // Create a copy of the array
    newArrayForRender.splice(i, 1); // Remove one element at the specified index

    setObjData(newArrayForRender);
    GetFolderShareList();
  };

  const secretKey = "your-secret-key"; // Replace with your secret key

  const encodeBase64UrlSafe = (input) => {
    return btoa(input)
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };

  const encryptedEmail = CryptoJS.AES.encrypt(email, secretKey).toString();
  const encryptedPass = CryptoJS.AES.encrypt(pass, secretKey).toString();
  const encryptedDate = CryptoJS.AES.encrypt(date, secretKey).toString();

  // let urlSafeFolderName= encryptedFolderName.replace(/\//g, "bbbb");
  // let urlSafeEmail = encryptedEmail.replace(/\//g, "bbbb");
  // let urlSafePass = encryptedPass.replace(/\//g, "bbbb");
  // let urlSafeDate = encryptedDate.replace(/\//g, "bbbb");
  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  const [copiedText, setCopiedText] = useState([]);

  const setTinyCopiedText = async (object_data, full_url, index) => {
    const isTrue = object_data?.pass && object_data?.date ? true : false;

    if (isTrue) {
      try {
        const response = await axios.get(
          `${UploadApi}/apiUpload/api-create?url=${encodeURIComponent(
            full_url
          )}`
        );

        const newCopiedText = [...copiedText];
        while (newCopiedText.length <= index) {
          newCopiedText.push("");
        }
        newCopiedText[index] = response.data || full_url;

        setCopiedText(newCopiedText);
      } catch (error) {
        const newCopiedText = [...copiedText];
        while (newCopiedText.length <= index) {
          newCopiedText.push("");
        }
        newCopiedText[index] = full_url;

        setCopiedText(newCopiedText);
      }
    } else {
      const newCopiedText = [...copiedText];
      while (newCopiedText.length <= index) {
        newCopiedText.push("");
      }
      newCopiedText[index] = full_url;

      setCopiedText(newCopiedText);
    }

    setIsLoadingTiny(false);
  };

  const TinyTextSharedFolders = async (full_url) => {
    try {
      const response = await axios.get(
        `${UploadApi}/apiUpload/api-create?url=${encodeURIComponent(full_url)}`
      );

      return response.data;
    } catch (error) {
      return full_url;
    }
  };

  const formatDateTime = (isoDateStr) => {
    try {
      const dateObj = new Date(isoDateStr);

      // Format date as YYYY-MM-DD
      const datePart = dateObj.toISOString().split("T")[0];

      // Format time as h:mm AM/PM
      const hours = dateObj.getHours();
      const minutes = dateObj.getMinutes().toString().padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      const formattedHour = hours % 12 || 12; // Convert 0 -> 12 for 12 AM
      const timePart = `${formattedHour}:${minutes} ${ampm}`;

      return "\t" + datePart + "\t" + timePart;
    } catch (error) {
      console.error(error);
      return "";
    }
  };

  return (
    <>
      <Dialog
        open={cOpen}
        onClose={() => setCOpen(false)}
        TransitionComponent={Transition}
        aria-describedby="alert-dialog-slide-description"
        fullScreen={fullScreen}
        PaperProps={{
          // style: {
          //   width: "70%",
          //   //   border: '1px solid white',
          // },
          sx: {
            width: { xs: "77%", sm: "57%", md: "none" },
            height: { xs: "77%", sm: "77%", md: "46%" },
            maxHeight: {
              xs: "none",
              sm: "calc(100% - 64px)",
              md: "calc(100% - 64px)",
            },
            maxWidth: { xs: "100%", sm: "none", md: "600px" },
          },
        }}
      >
        <DialogTitle
          sx={{
            // marginLeft: 5,
            display: "flex",
            flexDirection: { xs: "row", sm: "row" }, // Column on mobile, row on larger screens
            alignItems: "center",
            justifyContent: "space-between",
            fontSize: { xs: "small", sm: "small", md: "la" },
            gap: 1, // Adds spacing between buttons in column mode
          }}
        >
          {"Share folders"}{" "}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "row", sm: "row" },
              gap: 1,
            }}
          >
            <Button
              onClick={AddSharePerson}
              variant="contained"
              className="float-right flex "
            >
              {" "}
              <MdAdd />
              ADD
            </Button>
            {/* <span
            style={{
              cursor: "pointer",
            }}
            onClick={AddSharePerson}
            className="float-right flex "
          >
           
            ADD
          </span> */}
            <Button
              className="float-right flex "
              onClick={() => {
                setCOpen(false);
                // setshow(false);
                // setObjData([
                //   {
                //     email: "",
                //     pass: "",
                //     date: "",
                //     url: "",
                //   },
                // ]);
                // setPass("");
                // setDate("");
                // setArrayForRender([1]);
              }}
            >
              Back
            </Button>
          </Box>
        </DialogTitle>
        {/* {Both()} */}

        {ObjData?.map((e, i) => {
          return (
            <div className="mrc-single-share">
              <DialogContent
                // style={{ overflow: "hidden", marginLeft: 5 }}
                sx={{
                  overflowX: "hidden",
                  marginLeft: { xs: 0, sm: 0, md: 0 },
                  padding: {
                    xs: "0px 11px",
                    sm: "0px 24px;",
                    md: "5px 24px;",
                  },
                }}
              >
                <DialogContentText id="alert-dialog-slide-description">
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {e?.createdAt && (
                      <div>
                        Share URL created at:
                        {formatDateTime(e?.createdAt) || "N/A"}
                      </div>
                    )}
                    {e?.updatedAt &&
                      e?.updatedAt != "" &&
                      e?.updatedAt != "undefined" && (
                        <div>
                          Updated At:
                          {formatDateTime(e?.updatedAt) || "N/A"}
                        </div>
                      )}
                    <div
                      // style={{
                      //   display: "flex",
                      //   flexDirection: "row",
                      //   width: "540px",
                      // }}
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        width: { xs: "289px", sm: "540px", md: "540px" },
                      }}
                    >
                      <OutlinedInput
                        margin="normal"
                        required
                        fullWidth
                        label={"link"}
                        variant="outlined"
                        value={e?.url}
                        disabled={true}
                      />
                    </div>
                    <hr />
                    <Grid
                      container
                      spacing={2}
                      sx={{
                        marginTop: "-35px",
                        flexDirection: {
                          xs: "column",
                          sm: "column",
                          md: "row",
                        },
                      }}
                    >
                      {/* <Grid item xs={4}>
                        <br />
                        <TextField
                          hiddenLabel
                          label="User Name"
                          variant="outlined"
                          size="small"
                          // disabled={true}
                          type={"email"}
                          value={e.email}
                          onChange={(event) => {
                            // setEmail(e.target.value);
                            onChangeField(event, i);
                          }}
                          name="email"
                          // onChange={(e) => {setEmail(e.target.value);onChangeField(e)}}
                          style={{
                            borderRadius: "3px",
                            backgroundColor: "white",
                            width: 190,
                          }}
                        />
                      </Grid> */}
                      <Grid item xs={6} style={{ paddingLeft: 23 }}>
                        <br />
                        <TextField
                          autocomplete="new-password"
                          hiddenLabel
                          label="password"
                          variant="outlined"
                          size="small"
                          type={showPassword ? "text" : "password"}
                          // value={pass}
                          name="pass"
                          value={e.pass}
                          onChange={(event) => {
                            setDate(event.target.value);
                            onChangeField(event, i);
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={handleTogglePassword}
                                  edge="end"
                                >
                                  {showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          style={{
                            borderRadius: "3px",
                            backgroundColor: "white",
                            width: 250,
                          }}
                        />
                      </Grid>
                      <Grid item xs={6} style={{ paddingLeft: 10 }}>
                        <br />
                        <TextField
                          label="Expire Date"
                          InputLabelProps={{ shrink: true, required: true }}
                          variant="outlined"
                          size="small"
                          // value={date}
                          onChange={(event) => {
                            // setEmail(e.target.value);
                            onChangeField(event, i);
                          }}
                          type="date"
                          value={e.date}
                          min={
                            new Date().toISOString().substr(0, 19).split("T")[0]
                          }
                          style={{ borderRadius: "3px", width: 250 }}
                          name="date"
                        />
                      </Grid>
                    </Grid>
                  </div>
                </DialogContentText>
              </DialogContent>
              <div className="flex w-full items-center pl-4 p-1 group rounded text-dark">
                {!canShareState && (
                  <>
                    <input
                      id={`checkbox-item-${i}`}
                      type="checkbox"
                      name="canUpload"
                      checked={e?.canUpload == "yestofileupload"}
                      value={e?.canUpload == "yestofileupload"}
                      className="w-4 h-4 text-blue-600 bg-gray-100 text-dark border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                      onChange={(event) => {
                        onChangeField(event, i);
                      }}
                      disabled={e?.isKeyImagesOnly == "onlykeyimages"}
                      defaultChecked={e?.canUpload == "yestofileupload"} // Check if the folder is in selectedFolders
                    />
                    <label
                      htmlFor={`checkbox-item-${i}`}
                      className="w-full ms-2 text-sm font-medium rounded mb-0 text-gray-800 "
                    >
                      Allow file upload
                    </label>
                  </>
                )}
                {!viewKeyImagesOnly && (
                  <>
                    <input
                      id={`checkbox-keyimages-${i}`}
                      type="checkbox"
                      name="onlyKeyImages"
                      checked={e?.isKeyImagesOnly == "onlykeyimages"}
                      value={e?.isKeyImagesOnly == "onlykeyimages"}
                      className="w-4 h-4 text-blue-600 bg-gray-100 text-dark border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                      onChange={(event) => {
                        onChangeField(event, i);
                      }}
                      defaultChecked={e?.isKeyImagesOnly == "onlykeyimages"} // Check if the folder is in selectedFolders
                    />
                    <label
                      htmlFor={`checkbox-keyimages-${i}`}
                      className="w-full ms-2 text-sm font-medium rounded mb-0 text-gray-800 "
                    >
                      Only Key Images
                    </label>
                  </>
                )}

                {!canShareState && (
                  <>
                    <input
                      id={`checkbox-sharing-${i}`}
                      type="checkbox"
                      name="canShare"
                      checked={e?.canShare == "yesshare"}
                      value={e?.canShare == "yesshare"}
                      className="w-4 h-4 text-blue-600 bg-gray-100 text-dark border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                      onChange={(event) => {
                        onChangeField(event, i);
                      }}
                      defaultChecked={e?.canShare == "yesshare"} // Check if the folder is in selectedFolders
                    />
                    <label
                      htmlFor={`checkbox-sharing-${i}`}
                      className="w-full ms-2 text-sm font-medium rounded mb-0 text-gray-800 "
                    >
                      Allow File Sharing
                    </label>
                  </>
                )}
              </div>

              <DialogActions
                sx={{
                  marginBottom: "10px",
                  justifyContent: "center",
                  display: "flex",
                  flexWrap: "wrap", // Allow buttons to wrap on small screens
                  gap: 1, // Adds spacing between buttons
                  flexDirection: { xs: "row", sm: "row", md: "row", lg: "row" }, // Default to row
                  "& > *": { flex: { xs: "1 1 calc(50% - 8px)", md: "unset" } }, // 2 per row on mobile, all in 1 row on large screens
                }}
              >
                {/* Email button 
                {!canShareState && (
                  <Button
                    variant="contained"
                    disabled={e?.email && e?.pass && e?.date ? false : true}
                    onClick={() => {
                      setModal(true);
                      ShareFolderLink(e, i);
                      setselected(e);
                      // onClick={() =>
                      // SendEmail();
                    }}
                    // style={{ flex: "1 1 45%" }}
                    sx={{
                      fontSize: { xs: "xx-small", sm: "small", md: "small" },
                    }}
                  >
                    Send via email
                  </Button>
                )}
*/}
                {/* Back button  */}

                <Button
                  onClick={() => {
                    RemoveSharePerson(e, i);
                  }}
                  // style={{ flex: "1 1 45%" }}
                  sx={{
                    fontSize: { xs: "xx-small", sm: "small", md: "small" },
                  }}
                >
                  Remove
                </Button>

                {/* QR button */}
                {!canShareState && (
                  <Button
                    disabled={e?.email && e?.pass && e?.date ? false : true}
                    onClick={() => {
                      setshow(!show);

                      ShareFolderLink(e, i);
                    }}
                    // style={{ flex: "1 1 45%" }}
                    sx={{
                      fontSize: { xs: "xx-small", sm: "small", md: "small" },
                    }}
                  >
                    Share QR Code
                  </Button>
                )}

                {/* QR code  */}
                {show && (
                  <QRCode
                    size={256}
                    bgColor="#000000"
                    fgColor="#ffffff"
                    style={{
                      height: "auto",
                      maxWidth: "100%",
                      width: "15%",
                    }}
                    value={copiedText[i] || ""}
                    viewBox={`256 256 256 256`}
                  />
                )}

                {/* copy to clipboard */}
                <CopyToClipboard
                  text={`${copiedText[i]}
                                password: ${e?.pass}`}
                  // onClick={()=> {ShareFolderLink(e);}}
                >
                  <Button
                    variant="contained"
                    onClick={() => {
                      ShareFolderLink(e, i);
                      setIsOpen(true);
                      ShareData();
                      setTimeout(() => {
                        setIsOpen(false);
                      }, 2000);
                      saveCredentials({
                        accession: cAccession,
                        link: `${e?.url}/`,
                        CaseID: e?.email,
                        pass: e?.pass,
                      });
                    }}
                    disabled={
                      e?.email && e?.pass && e?.date
                        ? isLoadingTiny
                          ? true
                          : false
                        : true
                    }
                    // style={{ flex: "1 1 45%" }}
                    sx={{
                      fontSize: { xs: "xx-small", sm: "small", md: "small" },
                    }}
                  >
                    Copy to clipboard
                  </Button>
                </CopyToClipboard>
              </DialogActions>
            </div>
          );
        })}

        {/* {ArrayForRender.map((key, value) => Both(value))} */}
        <CustomizedSnackbars
          isOpen={isOpen}
          severity={"success"}
          message={"Credentials copied to clipboard"}
        />
      </Dialog>

      <Dialog
        open={modal}
        // TransitionComponent={Transition}
        TransitionComponent={Transition}
        style={{ height: "100%" }}
        PaperProps={{
          style: {
            height: "70%",
            //   border: '1px solid white',
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent style={{ overflow: "hidden", marginLeft: 5 }}>
          <DialogContentText id="alert-dialog-slide-description">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "540px",
                }}
              >
                <OutlinedInput
                  margin="normal"
                  required
                  fullWidth
                  label={"link"}
                  variant="outlined"
                  // value={`${window.origin}/signin/${urlSafeEmail}/${urlSafePass}/${urlSafeDate}`}
                  value={`${selected?.url}`}
                  disabled={true}
                />
              </div>
              <hr />
              <Grid container spacing={2} style={{ marginTop: "-35px" }}>
                {/* <Grid item xs={4} >
                                  
                                    
                                <br/>
                                    <TextField hiddenLabel label='Case ID'  variant='outlined' disabled={true} size="small" type={"email"} value={email}  style={{ borderRadius: "3px" , backgroundColor:'white',width:190}} />
                                </Grid> */}
                <Grid item lg={12} style={{ paddingLeft: 23 }}>
                  <br />
                  <TextField
                    autoFocus
                    hiddenLabel
                    label="Email"
                    variant="outlined"
                    size="small"
                    type={"email"}
                    value={emailToSend}
                    onChange={(e) => setEmailToSend(e.target.value)}
                    style={{
                      borderRadius: "3px",
                      backgroundColor: "white",
                      width: 500,
                    }}
                  />
                </Grid>
                <Grid item lg={12} style={{ paddingLeft: 23 }}>
                  <br />
                  <TextField
                    autoFocus
                    hiddenLabel
                    label="Subject"
                    variant="outlined"
                    size="small"
                    type={"text"}
                    value={"Sharing Study"}
                    style={{
                      borderRadius: "3px",
                      backgroundColor: "white",
                      width: 500,
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ marginRight: "22px", marginBottom: "10px" }}>
          {/* <Button variant="contained" disabled={email && pass && date ? false : true} onClick={()=>setModal(true)} >Share with email</Button> */}
          <Button
            onClick={() => {
              setModal(false);
              setObjData([
                {
                  email: "",
                  pass: "",
                  date: "",
                  url: "",
                },
              ]);
            }}
          >
            Back
          </Button>
          <Button variant="contained" onClick={() => SendEmail()}>
            Send Email
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
